module.exports = __webpack_public_path__ + "img/Pattern03.c333adcb.png";